export default __webpack_public_path__ + "static/media/background.e13a34b2.png";